export const buttonWrapperSelectorName = 'jira-native-issue-table-issue-row-button-wrapper';
export const buttonWrapperSelector = `[data-component-selector="${buttonWrapperSelectorName}"]`;
